import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FileControl } from 'commons/js/ui/Input'
import messages from './messages'
import { required as requiredValidator, maxBytesSize as maxBytesSizeValidator } from 'commons/js/util/validators'

const BYTES_IN_MBYTES = 1048576
export const megasToBytes = (megas) => megas * BYTES_IN_MBYTES

const FilesField = ({ intl, required, maxMegaBytesSize, ...restProps }) => (
    <FileControl
      model='.files[]'
      multiple
      validators={{
        required: required ? requiredValidator() : () => true,
        maxBytesSize: maxMegaBytesSize ? maxBytesSizeValidator(megasToBytes(maxMegaBytesSize)) : () => true,
      }}
      placeholder={intl.formatMessage(messages.placeholder)}
      autoComplete='off'
      errorMessages={{
        required: required ? intl.formatMessage(messages.requiredError) : () => true,
        maxBytesSize: maxMegaBytesSize ? intl.formatMessage(messages.maxBytesSizeError, { megas: maxMegaBytesSize }) : () => true,
      }}
      showClearButton={false}
      {...restProps}
    />
)

FilesField.propTypes = {
    intl: PropTypes.object,
    required: PropTypes.bool.isRequired,
    maxMegaBytesSize: PropTypes.number,
}

FilesField.defaultProps = {
    required: false,
    maxBytesSize: null,
}

export default injectIntl(FilesField)
